// Compatibility shim: re-export the WP-based aggregator implementation
// so legacy imports of `./popup-aggregator` keep working.
const {
	PopupAggregatorWP,
	popupAggregatorWP,
	usePreloadedPopupsWP,
} = require("./popup-aggregator-wp")

exports.PopupAggregator = PopupAggregatorWP
exports.popupAggregator = popupAggregatorWP
exports.usePreloadedPopups = usePreloadedPopupsWP
